import { isClientSide } from "@helper/utils";
import { useEffect } from "react";

import { updateGlobalStickyState } from "./updateGlobalStickyState";

export function useStickyVisibility() {
  useEffect(() => {
    if (!isClientSide) return;

    const onScroll = () => {
      let winTop = window.scrollY;

      const stickyHead = document.querySelector<HTMLElement>(
        '[data-testid="festival-wrapper"] > .festival > .relative + .sticky.top-0',
      );

      if (stickyHead) {
        winTop += stickyHead.offsetHeight;
      }

      const stickyCards = document.querySelectorAll<HTMLElement>(
        ".v_stickyArticleNow",
      );

      stickyCards.forEach((card) => {
        const article = card.closest<HTMLElement>(".article-card");
        if (!article) return;

        const featuredImage = article.querySelector<HTMLElement>(
          '[class*="article-carousel-wrapper-"]',
        );
        const headline = article.querySelector<HTMLElement>("article > h1");
        const keywords = article.querySelector<HTMLElement>(
          '[data-testid="tag-wrapper"] > span:last-of-type',
        );

        if (!featuredImage || !headline || !keywords) return;

        const summary = article.querySelector<HTMLElement>(
          "article .ai-summary",
        );

        // === EXACT offsetTop math ===
        const imgTop = summary
          ? summary.offsetTop
          : (featuredImage.previousElementSibling as HTMLElement).offsetTop;

        const imgHeight = summary
          ? summary.offsetHeight
          : (featuredImage.previousElementSibling as HTMLElement).offsetHeight;

        const imgEnd = imgTop + imgHeight;
        const keywordsTop = keywords.offsetTop;

        const shouldShow = winTop >= imgEnd && winTop <= keywordsTop;

        article.classList.toggle("v_showStickyBar", shouldShow);
        updateGlobalStickyState();
      });
    };

    // Run once on mount (important for SSR + reload)
    onScroll();

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
}
